import { Actor, Collider, CollisionContact, Color, Engine, Side } from 'excalibur';
import { controller } from '../../shared/controls/controller';
import { leftKeyboard } from '../../shared/controls/leftKeyboard';
export class Paddle extends Actor {
    constructor(engine: Engine) {
        super({
            name: 'paddle',
            x: 500,
            y: engine.drawHeight - 40,
            width: 400,
            height: 40,
            color: Color.Chartreuse,
        });
    }

    protected _speed = 1600;
    private _controller!: ReturnType<typeof controller> | ReturnType<typeof leftKeyboard>;
    override onInitialize(engine: Engine) {
        const gamepad = engine.input.gamepads.at(0);
        this._controller = gamepad?.connected ? controller(gamepad) : leftKeyboard(engine.input.keyboard);
    }

    override onPreUpdate(engine: Engine, elapsedMs: number): void {
        if (!this._controller) return;

        const speed = this._speed * (elapsedMs / 1000);
        if (this._controller.dpadLeft.holding || this._controller.leftStick.x < -0.1) {
            this.pos.x -= speed;
        }
        if (this._controller.dpadRight.holding || this._controller.leftStick.x > 0.1) {
            this.pos.x += speed;
        }

        // Clamp within screen bounds
        const halfWidth = this.width / 2;
        if (this.pos.x - halfWidth < 0) {
            this.pos.x = halfWidth;
        }
        if (this.pos.x + halfWidth > engine.drawWidth) {
            this.pos.x = engine.drawWidth - halfWidth;
        }
    }

    override onPostUpdate(engine: Engine, elapsedMs: number): void {
        // Put any update logic here runs every frame after Actor builtins
    }

    override onPreCollisionResolve(self: Collider, other: Collider, side: Side, contact: CollisionContact): void {
        // Called before a collision is resolved, if you want to opt out of this specific collision call contact.cancel()
    }

    override onPostCollisionResolve(self: Collider, other: Collider, side: Side, contact: CollisionContact): void {
        // Called every time a collision is resolved and overlap is solved
    }

    override onCollisionStart(self: Collider, other: Collider, side: Side, contact: CollisionContact): void {
        // Called when a pair of objects are in contact
    }

    override onCollisionEnd(self: Collider, other: Collider, side: Side, lastContact: CollisionContact): void {
        // Called when a pair of objects separates
    }
}
